<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { Link, navigateTo } from 'yrv'
    import VirtualList from '../../components/VirtualList/VirtualList.svelte'


    import axios from 'axios'
    import moment from 'moment'
    import wait from '../../libs/wait'
    import 'moment/locale/it'
    

    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import AdminLayout from '../../layouts/AdminLayout.svelte'
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import ProgramsSideContent from './ProgramsSideContent.svelte'
    import ProgramEditor from './ProgramEditor.svelte'
    import ProgramItem from './ProgramItem.svelte'
    import ProgramsCalendar from './CalendarView/ProgramsCalendar.svelte'
    import DayItem from './DayItem.svelte'
    import Dialog from '../../components/Modal/Dialog.svelte'
    import AlertsRenderer from './AlertsRenderer/AlertsRenderer.svelte'

    import userStore from '../../stores/user'
    import { height as windowHeight } from '../../stores/bounds'
    import storage from '../../libs/storage'
    import { periodStart, periodEnd, searchQuery } from '../../stores/programs'
    import { background, notifySuccess } from '../../components/Notifications/AppNotifications.svelte'


    export let id           /* id: stands for sector identifier */
    export let router
    
    const dispatch = createEventDispatcher ();
    
    let viewType        = 'calendar',
        model           = null,
        clients         = {},
        users           = {},
        category        = {},
        sidemodel       = null,
        sidebarHeight   = 0,

        before_ep       = 0,
        VLTop           = 0,
        VLViewport      = null,

        editorShown     = false,
        editorCreate    = false,
        loadedItem      = null,
        cloning         = false,

        viewBusy        = false,
        calendarRef     = null,
        calendarTimer   = null,
        calendarOpts    = {},

        alertsList      = [],
        alertMemo       = null

    
    moment.locale ('it');

    const interpolateProgramsList = (programs) => {
        let result      = [],
            date_s      = '',
            today_s     = moment().format ('DD MMM YYYY')

        programs.forEach (it => {
            let ds = moment (it.date).format ('DD MMM YYYY');

            if (ds !== date_s) {
                let isToday = today_s === ds;
                date_s = ds;
                result.push ({
                    id: Math.random (),
                    date: it.date,
                    text: ds,
                    _type: 'day-item',
                    isToday
                })
            }

            if (clients[it.client] !== undefined)
                it.client = clients[it.client];
            else {
                console.log ('client not found', it.client)
                it.client = { name: '==Client not found' };
            }
            it._type = 'program-item';
            result.push (it)
        });

        // console.log (result)

        return result;
    }

    const updateUsers = (data) => {
        users = { ...users, ...data }
        // console.log ('updateUsers', users)
    }

    const updateClients = (data) => {
        clients = { ...clients, ...data }
    }

    const initDateInterval = () => {
        let now = moment ();
        if (now.date() > 20)
            periodEnd.set (moment().add(1, 'months').endOf ('month').valueOf ());
        else
            periodEnd.set (moment().endOf ('month').valueOf ());
        periodStart.set (now.startOf ('month').valueOf ());
        // console.log ('initDateInterval', $periodStart)
    }

    const onViewChange = (event) => {
        viewType = event.detail;
    }

    const onPeriodChange = (event) => {
        const { start, end } = event.detail;
        // console.log (start, end)
        periodStart.set (start)
        periodEnd.set (end)
        fetchList ();
    }

    const onCalendarViewChange = (event) => {
        // console.log ('onCalendarViewChange', event.detail)
        if (calendarRef) {
            // console.log (calendarRef)
            calendarRef.changeView (event.detail)
        }
    }

    const onCalendarMonthChange = (event) => {
        if (calendarRef && event.detail === 'prev')
            calendarRef.prev ();
        else if (calendarRef && event.detail === 'next')
            calendarRef.next ();

        viewBusy = true;
    }

    const afterCalendarPeriodchange = (event) => {
        const { start, end, view } = event.detail;
        
        // console.log (view.getCurrentData ())
        calendarOpts.currentMonth = view.getCurrentData().viewTitle

        if (calendarTimer) {
            clearTimeout (calendarTimer);
            calendarTimer = null
        }

        calendarTimer = setTimeout (() => {
            // console.log ('onCalendarPeriodchange', event.detail)
            periodStart.set (start.getTime())
            periodEnd.set (end.getTime())
            fetchList ();
        }, 400)
    }

    const onProgramsSearch = (event) => {
        searchQuery.set (event.detail);
        fetchList ();
    }

    const filterProgramsList = list => {
        const clientsWhitelist = $userStore.clientsWhitelist.map(it => parseInt(it));
        // console.log ('clientsWhitelist', clientsWhitelist)
        return list.filter(it => {
            // console.log ('filter', it.client)
            if (clientsWhitelist.length === 0)
                return true;
            else
                return clientsWhitelist.includes(it.client);
        });
    }

    const filterAlertsList = list => {
        const clientsWhitelist = $userStore.clientsWhitelist.map(it => parseInt(it));
        return list.filter(it => {
            if (clientsWhitelist.length === 0)
                return true;
            else
                return clientsWhitelist.includes(it.client.id);
        });
    }

    const fetchList = () => {
        background (true);
        
        if ($periodStart === 0)
            initDateInterval ();

        // console.log ('programsStore', new Date($periodStart), new Date($periodEnd));
        viewBusy = true;
        background (true);
        axios.request ({
            method: 'post',
            url: '/api/programs/olist',
            params: {
                category: id,
                start: $periodStart,
                end: $periodEnd,
                query: $searchQuery
            }
        }).then (result => {
                updateClients (result.data.clients);
                updateUsers (result.data.users);

                model = interpolateProgramsList (filterProgramsList(result.data.programs));
                before_ep = result.data.before;
                sidemodel = {
                    sector: $userStore.sector,
                    start: $periodStart,
                    end: $periodEnd
                }
                fetchAlerts ($periodStart)

                background (false);
                viewBusy = false;
                if (router && router.query && router.query.scroll) {
                    setTimeout (() => {
                        restore_scroll (router.query.scroll)
                    }, 200)
                }
            }).catch (e => {
                viewBusy = false;
                background (false);
                dispatch ('app-event', { id: 'app-error', error: e });
            })
    }

    const loadMore = () => {
        let req_end     = moment($periodStart).valueOf (),
            req_start   = moment($periodStart).subtract(1, 'month').valueOf ();

        
        
        periodStart.set (req_start);
        background (true);
        axios.request ({
            method: 'post',
            url: '/api/programs/olist',
            params: {
                category: id,
                end: req_end,
                start: req_start,
                query: $searchQuery
            }
        })
        .then (result => {
            updateClients (result.data.clients);
            updateUsers (result.data.users);
            
            model = model.concat (interpolateProgramsList (filterProgramsList(result.data.programs)));
            before_ep = result.data.before;

            background (false);
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
        
        
        // dispatch ('app-event', { id: 'background', value: true });
        // axios.get (`/api/programs/olist?category=${id}&before=${before_ep}`)
        //     .then (result => {
        //         updateClients (result.data.clients);
        //         updateUsers (result.data.users);
                
        //         model = model.concat (interpolateProgramsList (result.data.programs));
        //         before_ep = result.data.before;

        //         dispatch ('app-event', { id: 'background', value: false });
        //     }).catch (e => {
        //         dispatch ('app-event', { id: 'app-error', error: e });
        //     })
    }

    const onCreateProgram = (event) => {
        editorShown = true;
        editorCreate = true
    }

    const onProgramDelete = (event) => {
        const { bean } = event.detail;
        // console.log ('onProgramDelete', bean)
        background (true)
        axios.request ({
            method: 'post',
            url: '/api/programs/delete',
            params: {
                id: bean.id
            }
        }).then (result => {
            fetchList ();
            background (false);
            notifySuccess ('Programma eliminato.')
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        });
    }

    const onProgramEdit = (event) => {
        const { detail} = event;
        const { bean } = detail;

        if (bean) {
            background (true);
            editorShown = true;
            axios.request ({
                method: 'post',
                url: '/api/programs/load',
                params: {
                    id: bean.id
                }
            }).then (result => {
                loadedItem = result.data.program;
                background (false)
            }).catch (e => {
                dispatch ('app-event', { id: 'app-error', error: e });
            })
        }
    }

    const onCalendarProgramDrop = (event) => {
        const { bean } = event.detail

        // console.log ('onCalendarProgramDrop', event.detail)
        // console.log (bean)
        // todo ask confirmation for move
        
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'post',
            url: '/api/programs/save?id=' + bean.id,
            data: {
                date: event.detail.start.getTime ()
            }
        }).then (result => {
            cloning = false;
            fetchList ();
            dispatch ('app-event', { id: 'confirm', value: true });
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    }

    const onProgramClone = (event) => {
        const { bean } = event.detail;
        cloning = true;
        loadedItem = {
            category: bean.category,
            client_data: bean.client,
            client: bean.client.id,
            creator: bean.creator,
            data: bean.data,
            date: '',
            description: bean.description,
            notes: bean.notes,
            operators: bean.operators.join (','),
            oprts: bean.operators.map (it => users[it]),
            type: bean.type,
            zone: bean.zone
        }
        editorShown = true;
        // console.log ('clone', JSON.stringify (loadedItem, null, '  '))
    }

    const onEditorSave = (event) => {
        const { detail } = event;
        const requestData = { ...detail.data }
        requestData.type = parseInt (requestData.type)
        // console.log ('editorSave', requestData, loadedItem);
        delete requestData.zone;

        // if (loadedItem) {
        //     delete requestData.category;
        // }

        if (requestData.data === undefined)
            requestData.data = '';

        // console.log ('requestData', requestData)
        background (true)
        axios.request ({
            method: 'post',
            url: '/api/programs/save' + (loadedItem && cloning === false ? ('?id=' + loadedItem.id) : ''),
            data: requestData
        }).then (result => {
            cloning = false;
            
            if (alertMemo) {
                saveAlertMemo (result.pid).then (() => {
                    fetchList ();
                    // dispatch ('app-event', { id: 'confirm', value: true });
                    notifySuccess ('Programma salvato.')
                })
            } else {
                fetchList ();
                notifySuccess ('Programma salvato.')
                // dispatch ('app-event', { id: 'confirm', value: true });
            }
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        });
        
        
        editorShown = false
        editorCreate = false
        if (loadedItem)
            loadedItem = null
    }

    const onEditorCancel = (event) => {
        const { detail } = event;
        // console.log ('onEditorCancel', detail);
        editorShown = false
        editorCreate = false
        loadedItem = null
        alertMemo = null
    }

    const onProgramNotify = (event) => {
        const { detail} = event;
        const { bean } = detail;

        if (bean) {
            // console.log ('onProgramNotify', bean)
            axios.request ({
                method: 'post',
                url: '/api/programs/singleNotification',
                params: {
                    id: bean.id
                }
            }).then (result => {
                bean.notified = true;
                model = model;
                notifySuccess ('Notifica inviata.')
                // console.log ('notify', result.data)
            }).catch (e => {
                dispatch ('app-event', { id: 'app-error', error: e });
            })
            // /programs/singleNotification
        }
    }

    const onGroupNotify = (event) => {
        const { instant, bean } = event.detail;
        // console.log ('global notify', instant)

        bean.busy = true;
        model = model;
        axios.request ({
            method: 'post',
            url: '/api/programs/notification',
            params: {
                instant: instant,
                category: $userStore.sector.id
            }
        }).then (result => {
            setTimeout (() => {
                bean.busy = false;
                model = model
                notifySuccess ('Notifica inviata.')
            }, 700)
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    }

    const onViewclient = (event) => {
        const { detail} = event;
        const { bean } = detail;

        if (bean) {
            history.pushState({}, undefined, `/app/programs/1?pid=${bean.id}&scroll=${VLTop}`);
            setTimeout (() => {
                navigateTo (`/app/clients/${bean.client.id}/logs`)
            }, 50)
        }
    }

    const fetchAlerts = (periodEpoch) => {
        let monthVal = moment (periodEpoch).month () + 1
        background (true);
        axios.request ({
            method: 'get',
            url: '/api/alerts/list/' + $userStore.sector.id + '/' + monthVal
        }).then (results => {
            alertsList = filterAlertsList(results.data)
            background (false)
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    }

    const saveAlertMemo = (pid) => {
        return new Promise ((resolve, reject) => {
            alertMemo.date = new Date().getTime ()
            alertMemo.resolver = '-'
            if (pid)
                alertMemo.ref = 'p_' + pid;

            axios.request ({
                method: 'post',
                url: '/api/alerts/addMemo',
                data: alertMemo
            }).then (result => {
                console.log ('save memo', result.data);
                alertMemo = null;
                resolve ();
            }).catch (e => resolve ('error'));
        })
    }

    const onAlertSelect = (event) => {
        const { bean } = event.detail
        const payload = JSON.parse (bean.payload)
        // console.log ('onAlertSelect', bean)

        cloning = true;
        loadedItem = {
            category: id,
            client_data: bean.client,
            client: bean.client.id,
            // creator: '',
            data: payload.data,
            date: bean.nextInstance.millis,
            description: bean.description,
            notes: payload.notes,
            operators: payload.operators,
            oprts: payload.operators.split(',').filter(it => it !== '').map (it => users[it]),
            type: payload.type,
            zone: payload.zone
        }
        editorCreate = true;
        editorShown = true;
        alertMemo = {
            id: bean.nextInstance.id,
            ref: null,
            date: null,
            resolver: null
        }
        // console.log ('alert', JSON.stringify (loadedItem, null, '  '))
    }

    const onAlertResolve = (event) => {
        const { bean } = event.detail
        alertMemo = {
            id: bean.nextInstance.id,
            ref: null,
            date: null,
            resolver: null
        }
        dispatch ('app-event', { id: 'background', value: true });
        saveAlertMemo().then (() => {
            fetchList();
            wait(200).then (() => {
                dispatch ('app-event', { id: 'background', value: false });
            })
        })
    }

    const restore_scroll = (scroll) => {
        VLViewport.scrollTo (0, scroll)
    }

    $: if ($userStore.clientsWhitelist) {
        fetchList (id)
    }
</script>


<Sidepanel>
    <ProgramsSideContent 
        {viewType} 
        {calendarOpts} 
        sector={$userStore.sector} 
        start={$periodStart} 
        end={$periodEnd} 
        bind:contentHeight={sidebarHeight}
        on:create={onCreateProgram} 
        on:view-change={onViewChange} 
        on:period-change={onPeriodChange} 
        on:calendar-view-change={onCalendarViewChange} 
        on:month-change={onCalendarMonthChange} 
        on:search={onProgramsSearch} />
    
    <AlertsRenderer 
        busy={viewBusy} 
        unix={$periodStart} 
        items={alertsList} 
        height={$windowHeight - sidebarHeight} 
        on:select={onAlertSelect} 
        on:resolve={onAlertResolve} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="ProgramsList avoid-selection">
        <div class="clearfix">
            {#if model}
                {#if viewType === 'list'}
                    <FadeinFX delay={400} delayOut={0}>
                        <VirtualList items={model} height="{$windowHeight}px" bind:top={VLTop} bind:viewport={VLViewport} let:item>
                            {#if item._type === 'program-item'}
                                <ProgramItem 
                                    {users} 
                                    data={item} 
                                    currentUserId={$userStore.token_id}
                                    on:edit={onProgramEdit} 
                                    on:clone={onProgramClone} 
                                    on:delete={onProgramDelete} 
                                    on:notify={onProgramNotify} 
                                    on:client={onViewclient} />
                            {:else if item._type === 'day-item'}
                                <DayItem data={item} on:notify={onGroupNotify} />
                            {/if}

                            {#if model.indexOf (item) === model.length - 1}
                                <div>
                                    <div class="load-more" on:click={loadMore}>
                                        Carica altri prima di {moment(before_ep).format ('DD MMM YYYY')}
                                    </div>
                                </div>
                            {/if}
                        </VirtualList>
                    </FadeinFX>
                {:else}
                    <FadeinFX delay={400} delayOut={0}>
                        <ProgramsCalendar 
                            bind:ref={calendarRef} 
                            items={model} 
                            busy={viewBusy} 
                            on:event-click={onProgramEdit} 
                            on:event-drop={onCalendarProgramDrop} 
                            on:period-change={afterCalendarPeriodchange} />
                    </FadeinFX>
                {/if}
            {/if}
        </div>
    </div>
</AdminLayout>

{#if editorShown}
    <ProgramEditor {users} data={loadedItem} create={editorCreate} on:save={onEditorSave} on:cancel={onEditorCancel} on:app-event />
{/if}


<style>
    .ProgramsList :global(svelte-virtual-list-viewport) {
        padding: 20px;
    }

    .ProgramsList :global(.ps__thumb-y) {
        background-color: #72929c;
    }
    .load-more {
        display: inline-block;
        margin-top: 10px;
        font-size: 12px;
        font-weight: 600;
        padding:  1px 10px;
        background-color: #72929c;
        color: #fff;
        border-radius: 5px;
    }
    .load-more:hover {
        background-color: #24c1ff;
    }

    .ProgramsList :global(.no-results-item) {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: 600;
    }
</style>